import { render } from "./NewsletterForm.vue?vue&type=template&id=0bcf23b4&scoped=true"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"

import "./NewsletterForm.vue?vue&type=style&index=0&id=0bcf23b4&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcf23b4"]])

export default __exports__